import { languagesMap } from 'constants/languages';
import i18next from 'i18next';
import { DateFormats } from 'infrastructure/enums';
import { DateFormatter } from 'infrastructure/functions';

export const DATE_FORMAT = DateFormats['MM/dd/yyyy'];

export const PROGRAM_COLORS: Record<string, { bg: string; color: string }> = {
  RPM: { bg: 'var(--ant-volcano-1)', color: 'var(--ant-volcano-6)' },
  CCM: { bg: 'var(--ant-blue-1)', color: 'var(--ant-blue-6)' },
  PCM: { bg: 'var(--ant-green-1)', color: 'var(--ant-green-6)' },
  DEFAULT: { bg: 'var(--ant-purple-1)', color: 'var(--ant-purple-6)' },
};

export const formatDateCell = (value?: string | null) => {
  if (!value) return i18next.t('labels.notAvailable');
  return DateFormatter({
    date: value,
    format: DATE_FORMAT,
  });
};

export const formatLanguage = (language?: string | null) => {
  if (!language) return i18next.t('labels.notAvailable');
  return languagesMap[language] ?? language;
};

export const getInitials = (name: string) => {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((chunk) => chunk[0]?.toUpperCase() ?? '')
    .join('');
};
